import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <div className="h-screen bg-cream flex items-center justify-center px-6">
      <div className="text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-9xl font-bold font-cormorant text-cocoa mb-4">404</h1>
          <h2 className="text-2xl md:text-4xl font-light mb-8 text-cocoa">
            Oops! La page que vous recherchez n'existe pas.
          </h2>
          <Link to="/">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-cocoa text-cream px-8 py-3 rounded-full hover:bg-brandy-rose transition-colors"
            >
              Retourner à l'accueil
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;